import React, { useState, useEffect, useContext } from 'react';
import InputLogin from '../../inputs/InputLogin'
import Switch from '../../switch/Switch'
import TextArea from '../../textArea/TextArea'
import UploadPDF from '../../inputs/UploadPDF'
import SearchableSelect from '../../select/SearchableSelect'
import ButtonBack from '../../button/ButtonBack'
import ButtonNext from '../../button/ButtonWhite'

import { UtilContext } from "../../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../../language/language";

import { ReactComponent as BACK } from '../../../assets/IconsColurs/IconsGeneral/chevronLeft.svg'
import { ReactComponent as NEXT } from '../../../assets/IconsColurs/IconsGeneral/chevronRight.svg'


const Step2 = ({
  documentsStep2,

  haveVirtualAsset,
  byLicensed,
  haveAml,
  haveComplianceOfficer,
  haveInternationalTransaction,
  otherIncomeId,
  otherIncomeDescription,
  haveOtherIncome,
  taxCountry,
  totalEquityId,
  totalLiabilityId,
  totalAssetId,
  monthlyExpensesId,
  monthlyIncomeId,
  categoryDescription,
  categoryId,
  setCategoryId,
  setCategoryDescription,
  setMonthlyIncomeId,
  setMonthlyExpensesId,
  setTotalAssetId,
  setTotalLiabilityId,
  setTotalEquityId,
  setTaxCountry,
  seThaveOtherIncome,
  setOtherIncomeDescription,
  setotherIncomeId,
  sethaveInternationalTransaction,
  sethaveAml,
  setByLicensed,
  byLicensedDoc,
  setByLicensedDoc,
  sethaveComplianceOfficer,
  sethaveVirtualAsset,
  setdocumentsStep2,
  haveInternationalTransactionCountry,
  sethaveInternationalTransactionCountry,
  haveInternationalTransactionNumber,
  sethaveInternationalTransactionNumber,
  haveInternationalTransactionEntidad,
  sethaveInternationalTransactionEntidad,
  haveInternationalTransactionRango,
  sethaveInternationalTransactionRango,
  onClick,
  ListCountry,
  ListRange,
  DocyearStatus,
  setDocyearStatus,
  listCategory,
  errorMesagge,

  /* Manejo de errores */
  onClickBack,
  loading,
  categoryIdError,
  categoryIdReadOnly,
  categoryDescriptionError,
  categoryDescriptionReadOnly,
  monthlyIncomeIdError,
  monthlyIncomeIdReadOnly,
  monthlyExpensesIdError,
  monthlyExpensesIdReadOnly,
  totalAssetIdError,
  totalAssetIdReadOnly,
  totalLiabilityIdError,
  totalLiabilityIdReadOnly,
  totalEquityIdError,
  totalEquityIdReadOnly,
  taxCountryError,
  taxCountryReadOnly,
  haveOtherIncomeError,
  haveOtherIncomeReadOnly,
  otherIncomeDescriptionError,
  otherIncomeDescriptionReadOnly,
  otherIncomeIdError,
  otherIncomeIdReadOnly,
  haveInternationalTransactionError,
  haveInternationalTransactionReadOnly,
  DocyearStatusError,
  DocyearStatusReadOnly,
  haveInternationalTransactionCountryError,
  haveInternationalTransactionCountryReadOnly,
  haveInternationalTransactionNumberError,
  haveInternationalTransactionNumberReadOnly,
  haveInternationalTransactionEntidadError,
  haveInternationalTransactionEntidadReadOnly,
  haveInternationalTransactionRangoError,
  haveInternationalTransactionRangoReadOnly,
  haveAmlError,
  haveAmlReadOnly,
  byLicensedError,
  byLicensedReadOnly,
  byLicensedDocReadOnly,
  haveComplianceOfficerError,
  haveComplianceOfficerReadOnly,
  haveVirtualAssetError,
  haveVirtualAssetReadOnly,
  internationalTransactionsError,
  internationalTransactionsReadOnly,
  documentsStep2Error,
  documentsStep2ReadOnly,
  byLicensedDocError,
  LoadingBack,
  error,
  LoadingLayouts
}) => {
  const [MoreIngresos, setMoreIngresos] = useState(false)
  const [Licencia, setLicencia] = useState(false)
  const [isReady, setIsReady] = useState(false);

  const { language } = useContext(UtilContext); // Usa el contexto de Auth


  useEffect(() => {
    if (
      !LoadingLayouts

    ) {
      setIsReady(true)
    }
  }, [
    LoadingLayouts
  ]);
  console.log(language, 'manda');


  if (!isReady) {
    return <div className="flex md:flex-row flex-wrap p-4 w-full" >
      <div className="w-full" >
        <div style={{ height: "50vh", }} className='flex items-center justify-center'>
          <div className="h-20  w-20 flex">
            <div className="spinner-border-white-full animate-spin w-14 h-14 border-4 border-white border-t-transparent rounded-full"></div>

          </div>
        </div>
      </div>
    </div>

  }
  return (
    <div className="w-full h-fit pb-16 gap-6 flex flex-col">
      <div className="space-y-4">
        <div>
          <p className="text-2xl mt-8" style={{ fontFamily: "brico" }}>{GLOBAL_LANGUAGE[language].steps2.title}</p>
          {language !== 'es' && <p className='text-[#E4E4E4]'>{GLOBAL_LANGUAGE[language].steps2.description}</p>}
        </div>

        <div>
          <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.label_activity_economic}</p>
          <SearchableSelect label={categoryId?.name} setSelectOpcion={setCategoryId} list={listCategory} error={categoryIdError} readOnly={categoryIdReadOnly} />
        </div>

        <div className='w-full'>
          <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.description_activity_economic}</p>
          <TextArea onChange={setCategoryDescription} value={categoryDescription} error={categoryDescriptionError} readOnly={categoryDescriptionReadOnly} placeholder={GLOBAL_LANGUAGE[language].steps2.activity_economic_placeholder} subtitleLeft={GLOBAL_LANGUAGE[language].steps2.min_caracters} />
        </div>

        <div className='flex flex-col md:flex-row gap-4'>
          <div className='w-full md:w-1/2'>
            <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.monthly_income}</p>
            <SearchableSelect setSelectOpcion={setMonthlyIncomeId} label={monthlyIncomeId?.range} list={ListRange} error={monthlyIncomeIdError} readOnly={monthlyIncomeIdReadOnly} />
          </div>
          <div className='w-full md:w-1/2'>
            <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.monthly_expenses}</p>
            <SearchableSelect label={monthlyExpensesId?.range} list={ListRange} setSelectOpcion={setMonthlyExpensesId} error={monthlyExpensesIdError} readOnly={monthlyExpensesIdReadOnly} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row gap-4'>
          <div className='w-full md:w-1/2'>
            <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.total_assets}</p>
            <SearchableSelect label={totalAssetId?.range} setSelectOpcion={setTotalAssetId} list={ListRange} error={totalAssetIdError} readOnly={totalAssetIdReadOnly} />
          </div>
          <div className='w-full md:w-1/2'>
            <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.total_liabilities}</p>
            <SearchableSelect label={totalLiabilityId?.range} setSelectOpcion={setTotalLiabilityId} list={ListRange} error={totalLiabilityIdError} readOnly={totalLiabilityIdReadOnly} />
          </div>
        </div>

        <div className='flex flex-col md:flex-row gap-4'>
          <div className='w-full md:w-1/2'>
            <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.total_equity}</p>
            <SearchableSelect label={totalEquityId?.range} setSelectOpcion={setTotalEquityId} list={ListRange} error={totalEquityIdError} readOnly={totalEquityIdReadOnly} />
          </div>
          <div className='w-full md:w-1/2'>
            <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.country_taxes}</p>
            <SearchableSelect label={taxCountry} setSelectOpcion={setTaxCountry} list={ListCountry} error={taxCountryError} readOnly={taxCountryReadOnly} />
          </div>
        </div>

        <div>
          <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].documents.financial_statements}</p>
          <UploadPDF setUploadedFile={setDocyearStatus} uploadedFile={DocyearStatus} error={DocyearStatusError} />
        </div>

        {language === 'es' && (
          <div className='flex flex-row justify-between w-full items-center'>
            <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.other_income}</p>
            <Switch value={haveOtherIncome} setValue={seThaveOtherIncome} />
          </div>
        )}

        {haveOtherIncome && (
          <div className='flex flex-col md:flex-row gap-4'>
            <div className='w-full md:w-1/2'>
              <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.other_income_description}</p>
              <InputLogin placeholder='Ingrese concepto' onChange={setOtherIncomeDescription} value={otherIncomeDescription} error={otherIncomeDescriptionError} readOnly={otherIncomeDescriptionReadOnly} />
            </div>
            <div className='w-full md:w-1/2'>
              <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.other_monthly_income}</p>
              <SearchableSelect label={otherIncomeId?.range} setSelectOpcion={setotherIncomeId} list={ListRange} error={otherIncomeIdError} readOnly={otherIncomeIdReadOnly} />
            </div>
          </div>
        )}

        {language === 'es' && (
          <div className='flex flex-row w-full justify-between items-center'>
            <p className='text-sm text-[#B7B7B9] flex-1 pr-4'>{GLOBAL_LANGUAGE[language].steps2.investments_or_operations_abroad}</p>
            <Switch setValue={sethaveInternationalTransaction} value={haveInternationalTransaction} />
          </div>
        )}

        {haveInternationalTransaction && (
          <div className='space-y-4'>
            <div>
              <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.contry_abroad}</p>
              <SearchableSelect label={haveInternationalTransactionCountry} setSelectOpcion={sethaveInternationalTransactionCountry} list={ListCountry} error={haveInternationalTransactionCountryError} readOnly={haveInternationalTransactionCountryReadOnly} />
            </div>

            <div className='flex flex-col md:flex-row gap-4'>
              <div className='w-full md:w-1/2'>
                <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.num_product_abroad}</p>
                <InputLogin value={haveInternationalTransactionNumber} onChange={sethaveInternationalTransactionNumber} error={haveInternationalTransactionNumberError} placeholder={'Ingrese el número'} readOnly={haveInternationalTransactionNumberReadOnly} />
              </div>
              <div className='w-full md:w-1/2'>
                <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.name_entity_abroa}</p>
                <InputLogin value={haveInternationalTransactionEntidad} onChange={sethaveInternationalTransactionEntidad} error={haveInternationalTransactionEntidadError} placeholder={'Nombre del banco'} readOnly={haveInternationalTransactionEntidadReadOnly} />
              </div>
            </div>

            <div>
              <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.value_transaction}</p>
              <SearchableSelect label={haveInternationalTransactionRango?.range} setSelectOpcion={sethaveInternationalTransactionRango} list={ListRange} error={haveInternationalTransactionRangoError} readOnly={haveInternationalTransactionRangoReadOnly} />
            </div>
          </div>
        )}

        {language === 'es' && (
          <div className='space-y-4'>
            <div className='flex flex-row justify-between w-full items-center'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.policy_aml}</p>
              <Switch setValue={sethaveAml} value={haveAml} />
            </div>

            <div className='flex flex-row justify-between w-full items-center'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.compliance_officer}</p>
              <Switch setValue={sethaveComplianceOfficer} value={haveComplianceOfficer} />
            </div>

            <div className='flex flex-row justify-between w-full items-center'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.license_required}</p>
              <Switch setValue={setByLicensed} value={byLicensed} />
            </div>

            {byLicensed && (
              <div>
                <p className='text-sm pb-1 text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.label_license_required}</p>
                <UploadPDF setUploadedFile={setByLicensedDoc} uploadedFile={byLicensedDoc} error={byLicensedDocError} />
              </div>
            )}

            <div className='flex flex-row justify-between w-full items-center'>
              <p className='text-sm text-[#B7B7B9]'>{GLOBAL_LANGUAGE[language].steps2.trade_with_virtual_assets}</p>
              <Switch setValue={sethaveVirtualAsset} value={haveVirtualAsset} />
            </div>
          </div>
        )}

        {error && (
          <div className="w-full">
            <p className="text-[#FF928B] text-[16px]">{errorMesagge}</p>
          </div>
        )}

        <div className='flex flex-col-reverse md:flex-row justify-between w-full gap-4'>
          <ButtonBack label={GLOBAL_LANGUAGE[language].steps2.label_button_back} Icon={BACK} onClick={onClickBack} loading={LoadingBack} className="w-full md:w-auto" />
          <ButtonNext label={GLOBAL_LANGUAGE[language].steps2.label_button_next} Icon={NEXT} onClick={onClick} loading={loading} className="w-full md:w-auto" />
        </div>
      </div>
    </div>
  );
};

export default Step2;

